export const userConstants = {
    LOAD_SETTINGS_SUCCESS: 'LOAD_SETTINGS_SUCCESS',
    LOAD_SETTINGS_FAILURE: 'LOAD_SETTINGS_FAILURE',
    RESET_SETTINGS: 'RESET_SETTINGS',
    SWITCH_CLIENT: 'SWITCH_CLIENT',
    SET_ITEMS_PER_PAGE: 'SET_ITEMS_PER_PAGE',
    SET_ELEMENTS_SETTING: 'SET_ELEMENTS_SETTING'
};
